<template>
  <!-- <v-container> -->
    <v-card  elevation="7">
      <v-row class="bm-0 mb-0 pb-0">
        <v-col cols="12">
          <v-card-subtitle class="ml-2">
            <h2 class="text-uppercase indigo--text">
              {{ currentUser.ponencia.magistrado }}
            </h2>
            <h4 class="text-uppercase" style="color: #616161">
              {{roleUser}}
              <span v-if="currentUser.presidente == 1"> presidente</span>
            </h4>
            <v-btn
              small
              class="white--text"
              style="float: right; margin-top: -39px;"
              color="#1D2E4B"
              @click="$router.push({ name:'Tocas' })"
            >
              Panel de Tocas
            </v-btn>
            <v-divider class="mt-3"/>
          </v-card-subtitle>
        </v-col>
        <v-col cols="12" clas="mt-0">
          <v-card class="mx-4" color="#CED7DB">
            <v-toolbar color="#1D2E4B" dark dense>
              <v-toolbar-title class="text-uppercase">Cuentas Colegiadas</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-card>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-card-title>
        <v-row>
          <v-col cols="12" sm="6">
            <h2 style="color: #c49b1f;word-break: break-word;">
              <span v-if="sesion_colegiada && sesion_colegiada.status ==0">
                Resumen de la Sesión Colegiada
              </span>
              <span v-else-if="cuentas_sesion && sesion_colegiada && sesion_colegiada.status ==1">
                Sesión Abierta de Cuenta Colegiada
              </span>
              <span v-else>Tocas para Sesionar (Colegiada)</span>
            </h2>
            <span v-if="sesion_colegiada">{{ sesion_colegiada.created_at | formatDateTime }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <v-menu
              v-model="menu_fecha_cuenta"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="fecha_cuenta"
                  label="Fecha Cuenta"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                  v-bind="attrs"
                  outlined
                  dense
                  :hint="fecha_cuenta | formatDate"
                  persistent-hint
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fecha_cuenta"
                @input="menu_fecha_cuenta= false"
                locale="es-mx"
                outlined
                @change="getCuentas()"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-title>
      <div v-if="currentUser.presidente == 1">
        <v-btn
          v-if="(!sesion_colegiada && cuentas_sesion) && (today == fecha_cuenta)"
          class="mr-4 mt-n4"
          style="float: right;"
          :loading="loading"
          :disabled="disabled"
          color="#1D2E4B"
          prepend-icon="mdi-cloud-upload"
          @click="abrirSesion()"
          dark
          dense
        >
          Abrir Sesión Colegiada
        </v-btn>
        <v-btn
          v-if="(sesion_colegiada && sesion_colegiada.status==1) &&
                (sesion_colegiada.total_colegiadas == sesion_colegiada.total_revisadas)"
          class="mr-4 mt-n4"
          style="float: right;"
          :loading="loading"
          :disabled="disabled"
          color="#1D2E4B"
          prepend-icon="mdi-cloud-upload"
          @click="cerrarColegiada()"
          dark
          dense
        >
          Terminar cuenta
        </v-btn>
      </div>
      <div v-else>
        <v-btn
          v-if="cuentas_sesion"
          class="mr-4 mt-n8"
          style="float: right;"
          :loading="loading"
          :disabled="disabled"
          color="#607D8B"
          prepend-icon="mdi-cloud-upload"
          @click="getCuentas()"
          dark
          dense
        >
          ACTUALIZAR
        </v-btn>
      </div>

      <v-progress-linear
        v-if="loading"
        class="mt-8"
        indeterminate
        color="blue darken-2"
      ></v-progress-linear>

      <!-- CUENTAS PARA SESIONAR-->
      <v-card
        v-if="(cuentas_sesion && !sesion_colegiada)  && !loading"
        elevation="0"
        class="my-4 mx-4 mt-8"
      >
        <hr><h3 align="center" style="background-color: gray; color: white;">
          TOCAS
        </h3><hr>
        <v-row class="mt-1">
          <v-col
            v-for="(ponencia, i) in cuentas_sesion"
            :key="'ponencia_' + i"
            cols="12"
            sm="4"
          >
            <v-card>
              <v-card-title style="background-color: #607D8B" class="darken-2 white--text" dense>
                <h5>{{ ponencia.nombre_magistrado }}</h5>
                <v-spacer></v-spacer>
              </v-card-title>
              <v-list>
                <v-list-item-group>
                  <span v-if="ponencia.cuentas.length!=0">
                    <v-list-item
                      v-for='(cuenta, i) in ponencia.cuentas'
                      :key="'cuenta_' + cuenta.id"
                      :value="cuenta.id"
                      @click="dialogDetalles=!dialogDetalles, cuenta_selected = cuenta"
                    >
                      <v-list-item-icon>
                        <v-icon color="grey darken-1">mdi-folder</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title v-text="`${cuenta.toca.numero}/${cuenta.toca.anio}`"></v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-icon
                          color="teal darken-1"
                          class="mr-1"
                        >
                          mdi-eye
                        </v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </span>
                  <span v-else>
                    <v-card-subtitle>
                      <b>SIN TOCAS PARA SESIONAR</b>
                    </v-card-subtitle>
                  </span>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </v-card>

      <!-- CUENTAS EN SESION COLEGIADA -->
      <v-card
        v-if="sesion_colegiada && !loading"
        elevation="0"
        class="my-4 mx-4 mt-8 font-weight-bold"
      >
        <div v-for="(colegiada, key_colegiada) in cuentas_sesion">
          <div >
            <hr>
              <h3 align="center" style="background-color: gray; color: white;">
                {{ colegiada.nombre_magistrado }}
              </h3>
            <hr>
            <v-data-table
              :headers="headers"
              :items="colegiada.cuentas"
              :items-per-page="5"
              class="elevation-1"
              hide-default-footer
              no-data-text="No hay Tocas por mostrar"
            >
              <template v-slot:header.colegiada_status="{ item }" v-if="sesion_colegiada && sesion_colegiada.status ==1">
                Revisado
              </template>
              <template v-slot:item.toca="{ item }" >
                {{ item.toca.numero }}/{{ item.toca.anio }}
              </template>
              <template v-slot:item.colegiada_status="{ item }" v-if="sesion_colegiada && sesion_colegiada.status ==1">
                <span v-if="item.colegiada.status==0">
                  <v-checkbox
                    v-if="currentUser.presidente == 1"
                    :disabled="!item.sentido_colegiada"
                    class="mt-n1"
                    color="blue"
                    hide-details
                    @click="revisarApelacion(item)"
                  ></v-checkbox>
                  <v-icon
                    v-else
                    class="mr-2"
                    color="grey"
                  >
                    mdi-minus
                  </v-icon>
                </span>
                <span v-else style="color: green;">
                  <v-icon
                    class="mr-2"
                    color="green"
                  >
                    mdi-check-bold
                  </v-icon>
                </span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  color="green"
                  text
                  outlined
                  small
                  @click="verDetalles(item)"
                >
                  VER
                </v-btn>
              </template>
              <template v-slot:item.sentido="{ item }">
                <span v-if="!item.sentido_colegiada">
                  <v-icon
                    class="mr-2"
                    color="grey"
                  >mdi-minus</v-icon>
                </span>
                <span v-else style="color: green;">
                  {{ item.sentido_colegiada }}
                </span>
              </template>
            </v-data-table>
          </div>
        </div>
      </v-card>

      <!-- NO HAY DATOS POR MOSTRAR -->
      <v-alert
        v-if="message && (!sesion_colegiada && !cuentas_sesion)"
        class="my-4 mx-4 mb-2 mt-9"
        prominent
        outlined
        type="error"
       >
        <v-row align="center" class="text-h5 font-weight-bold">
          <v-col v-if="today != fecha_cuenta">No existe Sesión de Cuenta colegiada!!!</v-col>
          <v-col v-if="today == fecha_cuenta">No hay Tocas para Sesionar hoy!!!</v-col>
        </v-row>
      </v-alert>
      <br>

      <!-- Dialog detalles cuenta -->
      <v-dialog
        v-if="dialogDetalles"
        v-model="dialogDetalles"
        scrollable
        fullscreen
        persistent
        transition="scale-transition"
      >
        <v-card>
          <v-card-title class="primary white--text">
            Toca: {{ cuenta_selected.toca.numero + '/' + cuenta_selected.toca.anio }}<br>
            {{ sesion_colegiada ? cuenta_selected.nombre_magistrado : '' }}<br v-if="sesion_colegiada">
            {{ sesion_colegiada ? cuenta_selected.nombre_relator : '' }}
            <v-spacer></v-spacer>
            <v-btn
              dark
              text
              @click="cerrarDialogDetalles()"
            >Cerrar
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-divider class="mt-4"></v-divider>
            <TableDetallesApelacion :apelacion="cuenta_selected.apelacion" />
            <v-divider class="mt-4"></v-divider>
            <!-- PROYECTO RESOLUCION -->
            <div class="mt-6">
              <h3>
                <b>PROYECTO DE RESOLUCIÓN:</b>
                <v-btn
                  v-if="cuenta_selected.resolucion_proyecto != null"
                  color="blue darken-1"
                  class="white--text mx-2"
                  @click="getResolucion()"
                  :loading="download_resolucion"
                >
                    Ver resolución&nbsp; <v-icon x-small>mdi-folder</v-icon>
                </v-btn>
                <span v-else style="color:red" class="ml-1">NO SE HA SUBIDO EL PROYECTO DE RESOLUCIÓN</span>
              </h3>
            </div>
            <v-divider class="mt-4"></v-divider>
            <div v-if="sesion_colegiada">
              <!-- SENTIDO -->
              <div class="mt-6">
                <h3>
                  SENTIDO PONENCIA: <span class="red--text"> {{ cuenta_selected.sentido_ponencia }}</span>
                </h3>
                <v-row class="mt-1">
                  <h3 class="mt-5 ml-3 mr-2">SENTIDO FINAL:</h3>
                  <v-col v-if="currentUser.presidente == 1 && (sesion_colegiada &&sesion_colegiada.status == 1)" class="ml-2 mr-2" cols="5">
                    <v-autocomplete
                      class="mb-n5"
                      dense
                      outlined
                      persistent-hint
                      :items = "getAllSentidos"
                      item-value="id"
                      item-text="nombre"
                      v-model="cuenta_selected.sentido_colegiada_id"
                      @change="updateSentidoFinal()"
                    />
                  </v-col>
                  <v-col v-else class="ml-5 mr-2 mt-2" cols="4">
                    <h3 class="green--text">{{ cuenta_selected.sentido_colegiada }}</h3>
                  </v-col>
                </v-row>
              </div>
              <v-divider class="mt-4"></v-divider>
              <!-- VOTOS-->
              <div class="mt-4"  style="border-style: ridge;">
                <v-toolbar color="#E0E0E0" dense flat>
                  <h3 class="font-weight-bold text-uppercase" style="color:">VOTOS</h3>
                  <v-checkbox
                    v-if="!cuenta_selected.colegiada.voto_particular && (sesion_colegiada && sesion_colegiada.status ==1)"
                    v-model="voto_particular"
                    class="mt-5 ml-4"
                    label="Voto Particular"
                  ></v-checkbox>
                  <v-checkbox
                    v-if="!cuenta_selected.colegiada.voto_concurrente && (sesion_colegiada && sesion_colegiada.status ==1)"
                    v-model="voto_concurrente"
                    class="mt-5 ml-4"
                    label="Voto Concurrente"
                  ></v-checkbox>
                </v-toolbar>
                <v-row class="mt-3 mb-3">
                  <v-col cols="6" v-if="voto_particular || cuenta_selected.colegiada.voto_particular">
                    <v-card elevation="6">
                      <v-card-title class="text-h6">
                        <v-icon left>
                          mdi-vote
                        </v-icon>
                        VOTO PARTICULAR
                      </v-card-title>
                      <v-card-subtitle
                        v-if="cuenta_selected.colegiada.voto_particular"
                        class="text-h8"
                      >
                        <v-list-item-title class="mt-3 mb-3">
                          {{ cuenta_selected.colegiada.voto_particular.magistrado_nombre }}
                        </v-list-item-title>
                        {{ cuenta_selected.colegiada.voto_particular.observaciones }}
                      </v-card-subtitle>
                      <v-card-subtitle v-if="!cuenta_selected.colegiada.voto_particular">
                        <v-autocomplete
                          dense
                          class="mt-n1"
                          outlined
                          label="Seleccione un magistrado"
                          :item-text="item => item.magistrado"
                          item-value="user_id"
                          persistent-hint
                          :items = "getAllPonencias"
                          v-model="mag_voto_particular"
                        />
                        <v-textarea
                          class="mt-n4 mb-n3"
                          v-model="obs_voto_particular"
                          outlined
                          placeholder="Observaciones del Voto Particular"
                          rows="1"
                        ></v-textarea>
                      </v-card-subtitle>
                      <v-card-actions class="mt-n9" v-if="sesion_colegiada && sesion_colegiada.status ==1">
                        <v-spacer></v-spacer>
                        <v-btn
                          v-if="!cuenta_selected.colegiada.voto_particular"
                          @click="guardarVoto('P')"
                          color="orange"
                          text
                        >
                          Guardar
                        </v-btn>
                        <v-btn
                          v-if="cuenta_selected.colegiada.voto_particular"
                          @click="clickEliminarVoto(cuenta_selected.colegiada.voto_particular)"
                          color="red"
                          text
                        >
                          Eliminar
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                  <v-col cols="6" v-if="voto_concurrente || cuenta_selected.colegiada.voto_concurrente">
                    <v-card elevation="6">
                      <v-card-title class="text-h6">
                        <v-icon left>
                          mdi-vote
                        </v-icon>
                        VOTO CONCURRENTE
                      </v-card-title>
                      <v-card-subtitle
                        v-if="cuenta_selected.colegiada.voto_concurrente"
                        class="text-h8"
                      >
                        <v-list-item-title class="mt-3 mb-3">
                          {{ cuenta_selected.colegiada.voto_concurrente.magistrado_nombre }}
                        </v-list-item-title>
                        {{ cuenta_selected.colegiada.voto_concurrente.observaciones }}
                      </v-card-subtitle>
                      <v-card-subtitle
                        v-if="!cuenta_selected.colegiada.voto_concurrente"
                      >
                        <v-autocomplete
                          dense
                          class="mt-n1"
                          outlined
                          label="Seleccione un magistrado"
                          :item-text="item => item.magistrado"
                          item-value="user_id"
                          persistent-hint
                          :items = "getAllPonencias"
                          v-model="mag_voto_concurrente"
                        />
                        <v-textarea
                          class="mt-n4 mb-n3"
                          v-model="obs_voto_concurrente"
                          outlined
                          placeholder="Observaciones del Voto Concurrente"
                          rows="1"
                        ></v-textarea>
                      </v-card-subtitle>
                      <v-card-actions class="mt-n9" v-if="sesion_colegiada && sesion_colegiada.status==1">
                        <v-spacer></v-spacer>
                        <v-btn
                          v-if="!cuenta_selected.colegiada.voto_concurrente"
                          @click="guardarVoto('C')"
                          color="orange"
                          text
                        >
                          Guardar
                        </v-btn>
                       <v-btn
                          v-if="cuenta_selected.colegiada.voto_concurrente"
                          @click="clickEliminarVoto(cuenta_selected.colegiada.voto_concurrente)"
                          color="red"
                          text
                        >
                          Eliminar
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
              <v-divider class="mt-4"></v-divider>
              <!-- OBSERVACIONES RELATOR-->
              <div class="mt-4"  style="border-style: ridge;"
                v-if="currentUser.ponencia.id == cuenta_selected.ponencia_id"
              >
                <v-toolbar color="#E0E0E0" dense flat>
                  <h3 class="font-weight-bold text-uppercase" style="color: #5D5D5D">Observaciones precuenta {{ cuenta_selected.nombre_relator }}</h3>
                </v-toolbar>
                <v-card-text>
                  <div class="mb-4" v-html="cuenta_selected.observaciones"></div>
                </v-card-text>
              </div>
              <v-divider class="mt-4" v-if="currentUser.ponencia.id == cuenta_selected.ponencia_id"></v-divider>
              <!-- OBSERVACIONES MAG-->
              <div class="mt-4"  style="border-style: ridge;"
                v-if="currentUser.ponencia.id == cuenta_selected.ponencia_id"
              >
                <v-toolbar color="#E0E0E0" dense flat>
                  <h3 class="font-weight-bold text-uppercase" style="color: #B58105">Observaciones precuenta {{ cuenta_selected.nombre_magistrado }}</h3>
                </v-toolbar>
                <v-card-text>
                  <div class="mb-4" v-html="cuenta_selected.observaciones_mag"></div>
                </v-card-text>
              </div>
              <v-divider class="mt-4" v-if="currentUser.ponencia.id == cuenta_selected.ponencia_id"></v-divider>
               <!-- COMPONENTE OBSERVACIONES COLEGIADA-->
              <!-- <ObservacionColegiada
                v-if="sesion_colegiada && sesion_colegiada.status ==1 "
                :cuenta_selected="cuenta_selected"
                :sesion_colegiada="sesion_colegiada"
                :role="roleUser"
              >
              </ObservacionColegiada> -->

              <!-- OBSERVACIONES MAG COLEGIADA-->
              <div class="mt-4" style="border-style: ridge;">
                <v-toolbar color="#E0E0E0" dense flat>
                  <h3 class="font-weight-bold text-uppercase" style="color: #2D5692">Observaciones de cuenta colegiada:</h3>
                  <v-spacer></v-spacer>
                  <v-icon
                    v-if="cuenta_selected.colegiada.observacion_colegiada"
                    color="green darken-2"
                  >
                    mdi-check-bold
                  </v-icon>
                </v-toolbar>
                <vue-editor
                  v-if="sesion_colegiada && sesion_colegiada.status ==1 "
                  v-model="observaciones_colegiada"
                  placeholder="Agregar observaciones..."
                ></vue-editor>
                <v-card-text v-else>
                  <div class="mb-4" v-html="observaciones_colegiada"></div>
                </v-card-text>
                <div align="center" class="mt-1">
                  <v-btn
                    v-if="sesion_colegiada && sesion_colegiada.status ==1 "
                    outlined
                    color="green"
                    @click="observacionColegiada()"
                    :disabled="!observaciones_colegiada"
                  >
                    guardar observaciones
                  </v-btn>
                </div>
              </div>
              <v-divider class="mt-4"></v-divider>
            </div>
            <!-- SACAR SESION -->
            <v-row v-if="currentUser.presidente==1 && (sesion_colegiada && sesion_colegiada.status == 1 || !sesion_colegiada)">
              <v-col cols="12" sm="4">
                <v-checkbox
                  class="mt-5"
                  v-model="sacar_sesion"
                  label="No sesionar el Toca"
                  color="red"
                  hide-details
                  @change="cambiar_fecha_cuenta=''"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" sm="4" v-if="sacar_sesion">
                <v-menu
                  v-model="menu_cambiar_fecha_cuenta"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      class="mt-4 mb-n5"
                      v-model="cambiar_fecha_cuenta"
                      label="Fecha Cuenta"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                      v-bind="attrs"
                      outlined
                      dense
                      persistent-hint
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="cambiar_fecha_cuenta"
                    @input="menu_cambiar_fecha_cuenta= false"
                    locale="es-mx"
                    outlined
                    :min="today"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4" v-if="sacar_sesion">
                <v-btn
                  class="mt-4 white--text"
                  :loading="loading"
                  :disabled="disabled || !cambiar_fecha_cuenta"
                  color="red darken-1"
                  prepend-icon="mdi-cloud-upload"
                  dense
                  block
                  @click="noSesionar(cuenta_selected)"
                >
                  Guardar Cambios
                </v-btn>
              </v-col>
            </v-row>
            <v-divider v-if="currentUser.presidente==1 && (sesion_colegiada && sesion_colegiada.status ==1)" class="mt-4"></v-divider>
          </v-card-text>
          <v-divider></v-divider>
          <!-- <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="cerrarDialogDetalles()"
            >
              Cerrar
            </v-btn>
          </v-card-actions> -->
        </v-card>
      </v-dialog>
      <!-- Fin Dialog  -->

    </v-card>
  <!-- </v-container> -->
</template>

<script>
  import TableDetallesApelacion from "@/components/TableDetallesApelacion";

  const Swal = require('sweetalert2');
  import { mapGetters } from "vuex";
  import { mapMutations } from "vuex";
  import { VueEditor } from 'vue2-editor';
 // import ObservacionColegiada from "../../components/ObservacionColegiada";

  export default {
   // components: { TableDetallesApelacion, ObservacionColegiada },
    components: { TableDetallesApelacion },
    props: {
      source: String
    },
    data(){
      return{
        dialogDetalles: false,
        activo: true,
        menu_fecha_cuenta: false,
        menu_cambiar_fecha_cuenta: false,
        today: '',
        fecha_cuenta: '',
        cambiar_fecha_cuenta:'',
        loading: false,
        disabled: false,
        sesion_colegiada: null,
        cuentas_sesion: null,
        cuenta_selected: null,
        sacar_sesion: false,
        message: false,
        observaciones_colegiada: '',
        voto_concurrente: false,
        voto_particular: false,
        mag_voto_particular: '',
        mag_voto_concurrente: '',
        obs_voto_particular:'',
        obs_voto_concurrente:'',
        headers: [
          { text: '', value: 'colegiada_status', sortable: false },
          { text: 'Toca', value: 'toca' },
          { text: 'Relator', value: 'nombre_relator', width: 200 },
          { text: 'Sentido Ponencia', value: 'sentido_ponencia', width: 200 },
          { text: 'Sentido Final', value: 'sentido', width: 200 },
          { text: 'Acciones', value: 'actions', sortable: false },
        ],
        ponencias_sin_excusas: null,
        download_resolucion: false
      }
    },
    computed: {
      ...mapGetters(["currentUser", "roleUser", "getAllSentidos", "getAllPonencias"]),
    },
    mounted() {
      var d = new Date();
      var mm = d.getMonth() + 1;
      if (mm<10) {
        mm = '0'+ mm
      }
      var dd = d.getDate();
      if (dd<10) {
        dd = '0'+ dd
      }
      var yy = d.getFullYear();
      this.today = yy + '-' + mm + '-' + dd;
      this.fecha_cuenta = yy + '-' + mm + '-' + dd;

      this.$store.dispatch("GET_ALL_SENTIDOS", { url: "/sentidos" });
      this.$store.dispatch("GET_PONENCIAS", { url: "ponencias" });
      this.loading = true
      this.getCuentas()
    },
    methods:{
      getCuentas(){
        this.message = false
        this.$store.dispatch("GET_CUENTAS_SESION", {
          url: '/cuentas-magistrado',
          params:  {
            fecha_cuenta: this.fecha_cuenta
          }
        }).then(response => {
          this.cuentas_sesion = response.data.data.cuentas
          this.sesion_colegiada = response.data.data.sesion_colegiada
          if (!this.cuentas_sesion && !this.sesion_colegiada) {
            this.message = true
          }
          this.loading = false

        });
      },
      verDetalles(cuenta){
        this.dialogDetalles = true
        this.cuenta_selected = cuenta
        if (cuenta.colegiada && cuenta.colegiada.observacion_colegiada) {
          this.observaciones_colegiada = cuenta.colegiada.observacion_colegiada.observaciones
        }
        // SI TIENE EXCUSAS, QUITAMOS MAGISTRADOS DEL LISTADO
        // this.ponencias_sin_excusas = Object.assign(this.getAllPonencias)
        // cuenta.apelacion.toca.excusas.forEach(function(item_excusa){
        //   this.ponencias_sin_excusas.forEach(function(item, index, object) {
        //     if (item.user_id === item_excusa.mag_excusado) {
        //       this.ponencias_sin_excusas.splice(index, 1);
        //     }
        //   }.bind(this))
        // }.bind(this));
      },
      noSesionar(cuenta){
        if (cuenta.fecha_cuenta == this.cambiar_fecha_cuenta) {
          this.$swal({
            title: "Error",
            text: "Para sacar de sesión, favor de seleccionar un día posterior al día de hoy!!!",
            icon: "error",
            confirmButtonText: "Aceptar"
          });
          return false;
        }
        this.$store.dispatch("UPDATE_APELACION", { url: "/cuenta/" + cuenta.id + "/no-sesionar",
          data:{
            fecha_cuenta: this.cambiar_fecha_cuenta
          }
        }).then(response => {
          if (response.status == 200) {
            this.$swal({
              title: "Éxito",
              text: "Fecha de cuenta actualizada correctamente!!!",
              icon: "success",
              confirmButtonText: "Aceptar"
            });
            this.dialogDetalles = false
            this.getCuentas()
          }
        }).catch(error => {
          console.log(error);
        });
      },
      abrirSesion(){
        this.loading = true
        this.$store.dispatch("CREATE_AMPARO",  { url: '/colegiada' }).then(response => {
          if(response.status == 200){
            this.getCuentas()
          }
        }).catch(error => {
          this.loading = false
          console.log(error);
        });
      },
      updateSentidoFinal(){
        this.$store.dispatch("CREATE_OBSERVACION", {
          url: '/cuenta/' + this.cuenta_selected.id + '/sentido-final',
          data: {
            sentido_colegiada_id: this.cuenta_selected.sentido_colegiada_id
          }
        }).then(response => {
          if (response.data.status == "ok") {
            this.$swal({
              title: "Éxito!!!",
              text: "Sentido final sido actualizado correctamente.",
              icon: "success",
              confirmButtonText: "Aceptar"
            });
            this.getCuentas()
          }
        }).catch(error => {
          console.log(error);
          this.loading = false;
          this.$swal({
            title: "Error",
            text: "No se pudo guardar",
            icon: "error",
            confirmButtonText: "Aceptar"
          });
        });
      },
      observacionColegiada(){
        if (this.cuenta_selected.colegiada.observacion_colegiada == undefined) {
          this.action = "CREATE_OBSERVACION_COLEGIADA"
          this.url = '/colegiada/' + this.sesion_colegiada.id + '/observacion'
          this.textSwal = "Observación agregada correctamente."
        } else {
          this.action = "UPDATE_OBSERVACION_COLEGIADA"
          this.url = '/colegiada/' + this.cuenta_selected.colegiada.observacion_colegiada.id + '/observacion'
          this.textSwal = "Observación actualizada correctamente."
        }
        this.$store.dispatch(this.action, {
          url: this.url,
          data: {
            colegiada_id: this.cuenta_selected.colegiada.id,
            magistrado_id: this.currentUser.id,
            observaciones: this.observaciones_colegiada
          }
        }).then(response => {
          if (response.data.status == "ok") {
            this.cuenta_selected.colegiada.observacion_colegiada = this.observaciones_colegiada
            this.$swal({
              title: "Éxito!!!",
              text: this.textSwal,
              icon: "success",
              confirmButtonText: "Aceptar"
            });
          }
          this.getCuentas()
        }).catch(error => {
          console.log(error);
          this.loading = false;
          this.$swal({
            title: "Error",
            text: "Error al guardar",
            icon: "error",
            confirmButtonText: "Aceptar"
          });
        });
      },
      guardarVoto(tipo){
        if (tipo=='P') {
          this.magistrado = this.mag_voto_particular
          this.observaciones = this.obs_voto_particular
        } else {
          this.magistrado = this.mag_voto_concurrente
          this.observaciones = this.obs_voto_concurrente
        }
        if (!this.magistrado && !this.observaciones) {
          this.$swal({
            title: "Error!!!",
            text: 'Favor de seleccionar magistrado y/o agregar observaciones',
            icon: "error",
            confirmButtonText: "Aceptar"
          });
          return false;
        }
        this.$store.dispatch('CREATE_OBSERVACION_COLEGIADA', {
          url: '/colegiada/' + this.cuenta_selected.colegiada.id + '/voto',
          data: {
            colegiada_id: this.cuenta_selected.colegiada.id,
            user_id: this.currentUser.id,
            magistrado_id: this.magistrado,
            observaciones: this.observaciones,
            tipo: tipo
          }
        }).then(response => {
          if (response.data.status == "ok") {
            if (tipo=='P') {
              this.cuenta_selected.colegiada.voto_particular = response.data.data.voto
            } else {
              this.cuenta_selected.colegiada.voto_concurrente = response.data.data.voto
            }
            this.$swal({
              title: "Éxito!!!",
              text: 'Voto agregado correctamente',
              icon: "success",
              confirmButtonText: "Aceptar"
            });
          }
          this.getCuentas()
        }).catch(error => {
          console.log(error);
          this.loading = false;
          this.$swal({
            title: "Error",
            text: "Error al guardar",
            icon: "error",
            confirmButtonText: "Aceptar"
          });
        });
      },
      clickEliminarVoto(item){
        this.$swal({
         title: '¿Desea eliminar ' + (item.tipo == 'P' ? 'voto particular?' : 'voto concurrente?'),
         text: '',
         icon: 'question',
         showCancelButton: true,
         confirmButtonText: "Aceptar"
       }).then((result) => {
         if (result.value) {
           this.eliminarVoto(item);
         }
       })
      },
      eliminarVoto(item){
        this.$store.dispatch("DELETE_SENTIDO",  { url: "/voto/" + item.id } ).then(res => {
          if (item.tipo == 'P') {
            this.cuenta_selected.colegiada.voto_particular = null
          } else {
            this.cuenta_selected.colegiada.voto_concurrente = null
          }
          this.$swal({
            title: "Exito!!!",
            text: "Voto eliminado correctamente",
            icon: "success",
            confirmButtonText: "Aceptar"
          });
        });
      },
      revisarApelacion(item){
        this.$store.dispatch("UPDATE_APELACION", {
          url: '/colegiada/' + item.colegiada.id + '/revisar',
        }).then(response => {
          if (response.data.status == "ok") {
            this.$swal({
              title: "Éxito!!!",
              text: "Toca revisada correctamente!!!.",
              icon: "success",
              confirmButtonText: "Aceptar"
            });
            this.getCuentas()
          }
        }).catch(error => {
          console.log(error);
          this.loading = false;
          this.$swal({
            title: "Error",
            text: "No se pudo guardar",
            icon: "error",
            confirmButtonText: "Aceptar"
          });
        });
      },
      cerrarColegiada(){
        this.$store.dispatch("UPDATE_APELACION", {
          url: "/colegiada/" + this.sesion_colegiada.id + "/cerrar",
          data:{
            sesion_colegiada_id: this.sesion_colegiada.id
          }
        }).then(response => {
          if (response.status == 200) {
            this.$swal({
              title: "Éxito",
              text: "Sesión colegiada cerrada correctamente!!!",
              icon: "success",
              confirmButtonText: "Aceptar"
            });
            this.dialogDetalles = false
            this.getCuentas()
          }
        }).catch(error => {
          console.log(error);
        });
      },
      cerrarDialogDetalles(){
        this.dialogDetalles = false,
        this.cuenta_selected = null,
        this.sacar_sesion = false,
        this.cambiar_fecha_cuenta = '',
        this.observaciones_colegiada = ''
        this.voto_particular = false
        this.voto_concurrente = false
        this.mag_voto_particular  = ''
        this.obs_voto_particular  = ''
        this.mag_voto_concurrente  = ''
        this.obs_voto_concurrente = ''
        this.$store.dispatch("GET_PONENCIAS", { url: "ponencias" });
        this.getCuentas()
      },
      getResolucion() {
        this.download_resolucion = true;
        this.$store.dispatch("GET_FILE",  {
          url: "/cuenta/"+ this.cuenta_selected.resolucion_proyecto.id+"/file"
        }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('target' ,'_blank');
            document.body.appendChild(link);
            link.click();
            this.download_resolucion = false;
        }).catch(error => {
          console.log(error);
        });
      },
    }
  }
</script>
